import React, { useEffect, useState } from "react";
import './../css/NavBar.css';
import { House, NotebookPen, Megaphone, AlignJustify } from 'lucide-react';
import { useNavigate,useLocation } from "react-router-dom";
const NavBar = ({setSideBar}) => {
     const [homework_dot,setHomeWork] = useState("no");
    const [alert_dot,setAlert] = useState("active");
    const navigate = useNavigate();
    const setActive = (v)=>{
        navigate('/staff/'+v)
    }
      const location = useLocation();

      const [active,setActiveVar] = useState();
      useEffect(()=>{
              let pathname = location.pathname;

setActiveVar(pathname.replace("/staff/", ""))
      },[location])
   return (
    <>
       <div className="NavBar">
        <div className={`menu ${active === 'dashboard' ? 'active' : ''}`} onClick={() => setActive('dashboard')}>
          <House   />
          Home
        </div>
        <div className={`menu ${active === 'homework' ? 'active' : ''}`} onClick={() => setActive('homework')}>
          {homework_dot==='active'?(<div className="dot"></div>):''}
          
          <NotebookPen />
          Assignements
        </div>
        <div className={`menu ${active === 'alert' ? 'active' : ''}`} onClick={() => setActive('alert')}>
          {alert_dot==='active'?(<div className="dot"></div>):''}
          <Megaphone />
          Alert
        </div>
        <div className={`menu ${active === 'quiz' ? 'active' : ''}`} onClick={() => setSideBar(true)}>
<svg onClick={()=>setSideBar(true)} width="30" height="30" viewBox="0 0 24 24" fill="#333" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="3" width="8" height="8" rx="2"/>
  <rect x="14" y="3" width="8" height="8" rx="2"/>
  <rect x="3" y="14" width="8" height="8" rx="2"/>
  <rect x="14" y="14" width="8" height="8" rx="2"/>
</svg>          
        </div>
      </div>
    </>
  );
};

export default NavBar;
